export default "__VITE_ASSET__CZAftsfg__"